/* Swan Botanicals — global theme behaviour */
(function () {
  'use strict';

  /* ---- Mobile menu ---- */
  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');
  const overlay = document.querySelector('[data-nav-overlay]');

  function openMenu() {
    mobileNav && mobileNav.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeMenu() {
    mobileNav && mobileNav.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  menuToggle && menuToggle.addEventListener('click', openMenu);
  document.querySelectorAll('[data-menu-close]').forEach(function (el) {
    el.addEventListener('click', closeMenu);
  });

  /* ---- Cart drawer ---- */
  const cartDrawer = document.querySelector('[data-cart-drawer]');
  const cartToggle = document.querySelectorAll('[data-cart-toggle]');

  function openCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  cartToggle.forEach(function (el) {
    el.addEventListener('click', function (e) {
      if (cartDrawer) { e.preventDefault(); openCart(); }
    });
  });
  document.querySelectorAll('[data-cart-close]').forEach(function (el) {
    el.addEventListener('click', closeCart);
  });
  overlay && overlay.addEventListener('click', function () { closeMenu(); closeCart(); });

  /* ---- Refresh cart drawer markup ---- */
  function refreshCart() {
    fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const fresh = doc.querySelector('[data-cart-drawer-inner]');
        const current = document.querySelector('[data-cart-drawer-inner]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        updateCartCount();
      });
  }

  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
      });
  }

  /* ---- AJAX add to cart ---- */
  document.addEventListener('submit', function (e) {
    const form = e.target.closest('form[action$="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.textContent : '';
    if (btn) { btn.textContent = 'Adding…'; btn.disabled = true; }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshCart();
        openCart();
        if (btn) { btn.textContent = original; btn.disabled = false; }
      })
      .catch(function () {
        if (btn) { btn.textContent = original; btn.disabled = false; }
      });
  });

  /* ---- Quantity steppers (product + cart) ---- */
  document.addEventListener('click', function (e) {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    if (!input) return;
    let val = parseInt(input.value, 10) || 1;
    val += parseInt(step.getAttribute('data-qty-step'), 10);
    if (val < 1) val = 1;
    input.value = val;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---- Update / remove cart line from drawer ---- */
  document.addEventListener('click', function (e) {
    const rm = e.target.closest('[data-cart-remove]');
    if (!rm) return;
    e.preventDefault();
    const key = rm.getAttribute('data-cart-remove');
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    }).then(function () { refreshCart(); });
  });

  updateCartCount();
})();
